import cls from 'classnames';

import { PicsartIcon } from '../../../../../types';

import useStyles from './styles';

type NavHeaderProps = {
  leftIcon: PicsartIcon;
  text: string;
  rightIcon?: PicsartIcon;
  onLeftIconClick: (e: any) => void;
  onRightIconClick?: () => void;
  baseIconClassName: string;
};

export default function NavHeader({
  leftIcon: Left,
  text,
  rightIcon: Right,
  onLeftIconClick,
  onRightIconClick,
  baseIconClassName,
}: NavHeaderProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Left className={cls(baseIconClassName, classes.leftIcon)} onClick={onLeftIconClick} />
        <span className={classes.text}>{text}</span>
      </div>

      {Right && <Right className={cls(baseIconClassName)} onClick={onRightIconClick} />}
    </div>
  );
}
